var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFav = function SvgFav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5C39",
    fillRule: "evenodd",
    d: "M3.1 5.571a6.333 6.333 0 0 1 8.956 0 6.333 6.333 0 1 1 8.957 8.957l-8.957 8.956L3.1 14.528a6.333 6.333 0 0 1 0-8.957",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m12.056 5.571-.353.354a.5.5 0 0 0 .707 0zm0 17.913-.353.354a.5.5 0 0 0 .707 0zm.354-18.267a6.833 6.833 0 0 0-9.664 0l.707.708a5.833 5.833 0 0 1 8.25 0zm0 .708a5.833 5.833 0 0 1 8.25 0l.707-.708a6.833 6.833 0 0 0-9.664 0zm8.25 0a5.833 5.833 0 0 1 0 8.25l.707.706a6.833 6.833 0 0 0 0-9.664zm-8.25 17.913 8.957-8.957-.707-.707-8.957 8.957zM2.746 14.88l8.957 8.957.707-.707-8.957-8.957zm0-9.664a6.833 6.833 0 0 0 0 9.664l.707-.707a5.833 5.833 0 0 1 0-8.25z"
  })));
};
export default SvgFav;